import { Injectable } from '@angular/core';

import { FirebaseSyncService } from '../services/firebase-sync.service';
import { JobDataService } from './job-data.service';
import { post } from 'selenium-webdriver/http';
import { AngularFirestore } from '@angular/fire/firestore';
import { PostcodeManagerService } from '../services/postcode-manager.service';
import { PricingService } from './pricing.service';
import { environment } from '../../environments/environment';
import { Clients, TradeTypes } from './globals.service';

@Injectable({
  providedIn: 'root'
})
export class MetaDataService {
  /*
    Question types
    1: free text
    2: booking windows
    3: contact details
    4: confirmation
    5: quantity
    6: 2 options
    7: select tap model
    8: numeric
    9: yes/no
    10: simple 2 options
    11: handyman duration
    12: Job notes & photos
    13: carpentry duration
  */

  public metaDataLoaded: boolean = false;
  public metaDataLoading: boolean = false;

  public currentPage: string = '';

  public contactEmail: string = '';
  public contactPhoneNumber: string = '';
  public contactEmergencyNumber: string = '';
  public contactPhoneHours: string = '';
  public faqData: Array<FAQItem> = [];
  public whereDidYouHearAboutUsData: Array<string> = [];

  public priceEstimatePopupPlumbing: string = 'The price provided is an estimated cost based on the information you have submitted. If the works differ upon inspection by our Tradie this estimate will be altered accordingly.<br /><br />Furthermore, any alterations to existing pipework may result in additional costs.<br /><br />Your Tradie will discuss this in further detail with you when on-site.'
  public priceEstimatePopupElectrical: string = 'The price provided is an estimated cost based on the information you have submitted. If the works differ upon inspection by our Tradie this estimate will be altered accordingly.<br /><br />Your Tradie will discuss this in further detail with you when on-site.';

  public tradeTypes: Array<TradeType> = [];
  public homePagetradeTypes: Array<TradeType> = [];
  public tapsJobTypes: Array<JobType> = [];
  public bookingMetadata: BookingMetadata;

  public standardQuestions: Array<TriageQuestion> = [];
  public currentTriageQuestion: TriageQuestionData = null;

  public postcodeCheck: boolean = false;

  public homeInspectionID: number = 5;

  constructor(
    public firebaseSync: FirebaseSyncService,
    public jobDataService: JobDataService,
    public db: AngularFirestore,
    public postcodeManager: PostcodeManagerService,
    public pricingService: PricingService,
    public clients: Clients,
    public eTradeTypes: TradeTypes
  ) {
    //
  }

  public IsAAHomeInspection(tradeType: number): boolean {
    if (tradeType == this.eTradeTypes.AAHealthyHomeInspection
      || tradeType == this.eTradeTypes.AABuildingInspection
      || tradeType == this.eTradeTypes.AARentalInspection
      || tradeType == this.eTradeTypes.AAMethamphetamineInspection
      || tradeType == this.eTradeTypes.AAAsbestosInspection) {
      return true;
    }

    return false;
  }

  public async loadMetaData() {
    // if (this.metaDataLoaded || this.metaDataLoading) {
    //   return;
    // }

    // this.metaDataLoading = true;

    let service: MetaDataService = this;
    let triageDataQuery = this.db.doc('/metadata/triage').ref;
    let siteDataQuery = this.db.doc('/metadata/site').ref;
    let postcodeDataQuery = this.db.doc('/metadata/postcode').ref;
    let bookingMetadataQuery = this.db.doc('/metadata/booking').ref;

    await triageDataQuery.get().then(function (result) {
      let data = result.data();
      service.tradeTypes = JSON.parse((<any>data).tradeTypes);
      service.tapsJobTypes = JSON.parse((<any>data).tapsJobTypes);
      service.standardQuestions = JSON.parse((<any>data).standardQuestions);

      service.homePagetradeTypes = [];

      service.tradeTypes.forEach(tradeType => {
        if (!tradeType.hideOnHomePage) {
          service.homePagetradeTypes.push(tradeType);
        }
      });

    }).catch(function (error) {
      console.log('ERROR triageDataQuery: ' + error);
    });

    await bookingMetadataQuery.get().then(function (result) {
      let data = result.data();
      service.bookingMetadata = (<BookingMetadata>data);
    }).catch(function (error) {
      console.log('ERROR bookingMetadataQuery: ' + error);
    });

    await postcodeDataQuery.get().then(function (result) {
      let data = result.data();
      let postcodeData = (<PostcodeData>data);

      service.postcodeManager.PostcodeGroups = [];

      for (let group of postcodeData.PostcodeGroups) {
        group.PublicHolidays = [];
        group.PricingAreas = [];
        group.BlackoutPeriods = [];
        group.PricingChanges = [];

        // find all blackout periods that cover this postcode group
        for (let blackoutPeriod of service.bookingMetadata.BlackoutPeriods) {
          if (blackoutPeriod.PostcodeGroup == group.Name) {
            group.BlackoutPeriods.push(blackoutPeriod);
          }
        }

        // find all public holiday groups that cover this postcode group
        for (let publicHolidayGroup of postcodeData.PublicHolidayGroups) {
          let addPublicHolidays = false;

          // convert strings to dates
          let tempDates = publicHolidayGroup.Dates;
          publicHolidayGroup.Dates = [];

          for (let d of tempDates) {
            publicHolidayGroup.Dates.push(new Date(d));
          }

          for (let postcodeGroup of publicHolidayGroup.PostcodeGroups) {
            if (group.Name == postcodeGroup) {
              addPublicHolidays = true;
            }
          }

          if (addPublicHolidays) {
            group.PublicHolidays.push(publicHolidayGroup);
          }
        }

        // find all pricing areas that cover this postcode group
        for (let pricingArea of postcodeData.PricingAreas) {
          let addPricingArea = false;

          for (let postcodeGroup of pricingArea.PostcodeGroups) {
            if (group.Name == postcodeGroup) {
              addPricingArea = true;
            }
          }

          if (addPricingArea) {
            group.PricingAreas.push(pricingArea);
          }
        }

        // find all pricing changes that cover this postcode group
        if (postcodeData.PricingChanges != null && postcodeData.PricingChanges.length > 0) {
          for (let pricingChange of postcodeData.PricingChanges) {
            let addPricingChange = false;

            for (let postcodeGroup of pricingChange.PostcodeGroups) {
              if (group.Name == postcodeGroup) {
                addPricingChange = true;
              }
            }

            if (addPricingChange) {
              group.PricingChanges.push(pricingChange);
            }
          }
        }

        let tempGroup = new PostcodeGroup();
        Object.setPrototypeOf(group, Object.getPrototypeOf(tempGroup));

        service.postcodeManager.PostcodeGroups.push(group);
      }

    }).catch(function (error) {
      console.log('ERROR postcodeDataQuery: ' + error);
    });

    await siteDataQuery.get().then(function (result) {
      let data = result.data();
      service.contactEmail = (<any>data).email;
      service.contactPhoneHours = (<any>data).phoneHours;
      service.contactPhoneNumber = (<any>data).phoneNumber;
      service.contactEmergencyNumber = (<any>data).emergencyNumber;

      let wdyhau: string = (<any>data).whereDidYouHearAboutUs;
      let faq: string = (<any>data).faq;

      if (wdyhau != null && wdyhau.length > 0) {
        service.whereDidYouHearAboutUsData = JSON.parse(wdyhau);
      }

      let cancelFee = 65;
      if (environment.clientID == service.clients.AANZ) {
        cancelFee = 35;
      }

      if (faq != null && faq.length > 0) {
        service.faqData = JSON.parse(faq);

        // replace the key with the value in faq titles and descriptions
        let faqReplace: { [index: string]: string } = {
          "{{productName}}": environment.productName,
          "{{contactEmail}}": service.contactEmail,
          "{{contactPhoneNumber}}": service.contactPhoneNumber,
          "{{contactPhoneHours}}": service.contactPhoneHours,
          "{{cancelFee}}": cancelFee.toString(),
        };

        service.faqData.forEach(f => {
          for (let key in faqReplace) {
            let value = faqReplace[key];
            f.title = f.title.split(key).join(value);
            f.description = f.description.split(key).join(value);
          }
        });
      }

    }).catch(function (error) {
      console.log('ERROR siteDataQuery: ' + error);
    });

    this.metaDataLoaded = true;
    this.metaDataLoading = false;
  }

  public checkPostcode(postcode: string, tradeTypeID: number): boolean {

    this.postcodeCheck = false;

    if (this.postcodeManager.SelectedPostcodeGroup != null) {
      this.postcodeCheck = this.postcodeManager.SelectedPostcodeGroup.IsPostcodeCovered(postcode);
    }
    if (this.postcodeCheck) {
      var tradeTypePricing = this.GetTradeTypePricing(tradeTypeID, postcode);

      if (tradeTypePricing == null) {
        this.postcodeCheck = false;
        return this.postcodeCheck;
      }

      if (tradeTypePricing != null) {
        if (tradeTypePricing.HourlyRate == 0) {
          if (tradeTypePricing.CalloutFee == 0) {
            // 20220620 - MM - if hourly rate and callout fee are both 0 for a given service, service not available in this postcode
            // 20220620 - MM - to set to 0, use HomeServicesDataApp > Pricing Areas, find relevant postcode group, and edit relevant service 
            this.postcodeCheck = false;
          }
        }
      }
    }
    return this.postcodeCheck;
  }

  public IsPostcodeCovered(postcode: string): boolean {
    for (let postcodeGroup of this.postcodeManager.PostcodeGroups) {
      for (let p of postcodeGroup.Postcodes) {
        if (postcode == p) {
          return true;
        }
      }
    }

    return false;
  }


  public pushAADataLayerPageView(postcode: string): void {
    if (environment.clientID != this.clients.AANZ) {
      return;
    }
    (<any>window).dataLayer.push({
      event: 'postcode_check',
      postcode: postcode,
    });
  }

  public pushAACompletedBooking(jobref: string, trade: string, estimate: string) {
    if (environment.clientID != this.clients.AANZ) {
      return;
    }

    (<any>window).dataLayer.push({
      event: 'completed_booking',
      estimate: estimate,
      job_reference: jobref,
      trade: trade,
    });
  }

  public pushAAStartTrade(trade: string) {
    if (environment.clientID != this.clients.AANZ) {
      return;
    }

    (<any>window).dataLayer.push({
      event: 'trade_selected',
      trade: trade,
    });
  }

  public pushAAStartExternalTrade(trade: string) {
    if (environment.clientID != this.clients.AANZ) {
      return;
    }
    (<any>window).dataLayer.push({
      event: 'external_trade_selected',
      trade: trade,
    });
  }

  public pushAAIsMemberSelected(isMember: boolean) {
    if (environment.clientID != this.clients.AANZ) {
      return;
    }
    (<any>window).dataLayer.push({
      event: 'is_aa_member',
      is_member: isMember,
    });
  }

  public convertURLName(name: string) {
    var newName = name.split(' ').join('-');
    newName = newName.split('_').join('-');

    return newName.toLowerCase();
  }

  public GetPostcodeGroups(postcode: string): Array<PostcodeGroup> {
    let groups = new Array<PostcodeGroup>();

    for (let group of this.postcodeManager.PostcodeGroups) {
      if (group.Postcodes.indexOf(postcode) > -1) {
        groups.push(group);
        continue;
      }
    }

    return groups;
  }

  public IsTradeTypeBlackoutDate(tradeTypeID: number, postcode: string, date: Date): boolean {
    let postcodeGroups = this.GetPostcodeGroups(postcode);

    if (postcodeGroups == null || postcodeGroups.length == 0) {
      return false;
    }

    for (let postcodeGroup of postcodeGroups) {
      for (let blackoutPeriod of postcodeGroup.BlackoutPeriods) {
        if (blackoutPeriod.TradeTypeID == tradeTypeID
          && date >= new Date(blackoutPeriod.StartDate)
          && date <= new Date(blackoutPeriod.EndDate)) {
          return true;
        }
      }
    }

    return false;
  }

  public GetTradeTypePricing(tradeTypeID: number, postcode: string): TradeTypePricing {
    let postcodeGroups = this.GetPostcodeGroups(postcode);

    if (postcodeGroups == null || postcodeGroups.length == 0) {
      return null;
    }

    for (let group of postcodeGroups) {
      var pricing = group.GetTradeTypePricing(tradeTypeID);

      if (pricing != null) {
        return pricing;
      }
    }

    return null;
  }

  public GetJobTypePricing(tradeTypeID: number, jobTypeID: number, postcode: string): JobTypePricing {
    let postcodeGroups = this.GetPostcodeGroups(postcode);

    if (postcodeGroups == null || postcodeGroups.length == 0) {
      return null;
    }

    for (let group of postcodeGroups) {
      var pricing = group.GetJobTypePricing(tradeTypeID, jobTypeID);

      if (pricing != null) {
        return pricing;
      }
    }

    return null;
  }

  public GetPricingChangeByJobTypeID(jobTypeID: number, postcode: string) {
    let postcodeGroups = this.GetPostcodeGroups(postcode);

    if (postcodeGroups == null || postcodeGroups.length == 0) {
      return null;
    }

    for (let group of postcodeGroups) {
      var pricing = group.GetPricingChangeByJobTypeID(jobTypeID);

      if (pricing != null) {
        return pricing;
      }
    }

    return null;
  }

  public GetPricingChangeByTradeTypeID(tradeTypeID: number, postcode: string) {
    let postcodeGroups = this.GetPostcodeGroups(postcode);

    if (postcodeGroups == null || postcodeGroups.length == 0) {
      return null;
    }

    for (let group of postcodeGroups) {
      var pricing = group.GetPricingChangeByTradeTypeID(tradeTypeID);

      if (pricing != null) {
        return pricing;
      }
    }

    return null;
  }

}

export class BlackoutPeriod {
  public TradeTypeID: number;
  public PostcodeGroup: string;
  public StartDate: string;
  public EndDate: string;
}

export class BookingMetadata {
  public BlackoutPeriods: Array<BlackoutPeriod> = [];
}

export class PostcodeData {
  public PostcodeGroups: Array<PostcodeGroup> = [];
  public PublicHolidayGroups: Array<PublicHolidaysGroup> = [];
  public PricingAreas: Array<PricingArea> = [];
  public PricingChanges: Array<PricingChange> = [];
}

export class PostcodeGroup {
  public Name: string = '';
  public Postcodes: Array<string> = [];
  public AllowNextDayBooking: boolean = false;
  public OverrideBlackoutDays: number = null;

  public PublicHolidays: Array<PublicHolidaysGroup> = [];
  public PricingAreas: Array<PricingArea> = [];
  public PricingChanges: Array<PricingChange> = [];
  public BlackoutPeriods: Array<BlackoutPeriod> = [];

  public IsPostcodeCovered(postcode: string): boolean {
    for (let p of this.Postcodes) {
      if (postcode == p) {
        return true;
      }
    }

    return false;
  }

  public IsPublicHoliday(date: Date): boolean {
    let dateString: string = date.toDateString();

    for (let publicHolidayGroup of this.PublicHolidays) {
      for (let d of publicHolidayGroup.Dates) {
        if (dateString == d.toDateString()) {
          return true;
        }
      }
    }

    return false;
  }

  public GetTradeTypePricing(tradeTypeID: number): TradeTypePricing {
    for (let pricingArea of this.PricingAreas) {
      for (let tradeType of pricingArea.TradeTypes) {
        if (tradeType.TradeTypeID == tradeTypeID) {
          return tradeType;
        }
      }
    }

    return null;
  }

  public GetJobTypePricing(tradeTypeID: number, jobTypeID: number): JobTypePricing {
    for (let pricingArea of this.PricingAreas) {
      for (let tradeType of pricingArea.TradeTypes) {
        if (tradeType.TradeTypeID == tradeTypeID) {
          for (let jobType of tradeType.JobTypes) {
            if (jobType.JobTypeID == jobTypeID) {
              return jobType;
            }
          }
        }
      }
    }

    return null;
  }

  public GetPricingChangeByTradeTypeID(tradeTypeID: number): PricingChange {
    if (this.PricingChanges == null || this.PricingChanges.length == 0) {
      return null;
    }

    for (let pricingChange of this.PricingChanges) {
      for (let tradeType of pricingChange.TradeTypes) {
        if (tradeType == tradeTypeID) {
          return pricingChange;
        }
      }
    }

    return null;
  }

  public GetPricingChangeByJobTypeID(jobTypeID: number): PricingChange {
    if (this.PricingChanges == null || this.PricingChanges.length == 0) {
      return null;
    }

    for (let pricingChange of this.PricingChanges) {
      for (let tradeType of pricingChange.JobTypes) {
        if (tradeType == jobTypeID) {
          return pricingChange;
        }
      }
    }

    return null;
  }

} // PostcodeGroup

export class PublicHolidaysGroup {
  public Name: string = '';
  public Dates: Array<Date> = [];
  public PostcodeGroups: Array<string> = [];
}

export class JobTypePricing {
  public JobTypeID: number;
  public PartsCostBase: number = null;
  public PartsCostPremium: number = null;
  public AttendanceHours: number = null;
  public HourlyRate: number = null;
  public CalloutFee: number = null;
  public OutOfHoursHourlyRate: number = null;
  public OutOfHoursCalloutFee: number = null;
  public AdditionalCalloutFee: number = null;
}

export class TradeTypePricing {
  public TradeTypeID: number;
  public JobTypes: Array<JobTypePricing> = [];
  public HourlyRate: number = null;
  public CalloutFee: number = null;
  public OutOfHoursHourlyRate: number = null;
  public OutOfHoursCalloutFee: number = null;
  public AdditionalCalloutFee: number = null;
  public OverrideBlackoutDays: number = null;
  public OverrideMemberDiscountPercent: string = null;
}

export class PricingArea {
  public Name: string = '';
  public PostcodeGroups: Array<string> = [];
  public TradeTypes: Array<TradeTypePricing> = [];
}

export class PricingChange {
  public Name: string = '';
  public PostcodeGroups: Array<string> = [];
  public TradeTypes: Array<number> = [];
  public JobTypes: Array<number> = [];
  public AddFlatFee: string;
  public AddHourlyRate: string;
  public AddCalloutFee: string;
  public AdditionalUnitCostOverrideMember: string;
  public AdditionalUnitCostOverrideNonMember: string;
}

export class FAQItem {
  public title: string = '';
  public description: string = '';
  public show: boolean = false;

  constructor(_title: string, _description: string) {
    this.title = _title;
    this.description = _description;
  }
}

export class Suburb {
  public postcode: number = 0;
  public name: string = '';
}

export class TradeType {
  public id: number = 0;
  public urlID: string = '';
  public name: string = '';
  public icon: string = '';
  public overrideBlackoutDays: number = -1;
  public link: string = '';
  public endPopup: string = '';
  public hourlyRate: number = 0;
  public calloutFee: number = 0;
  public nextDayBooking: boolean = false;
  public jobTypes: Array<JobType> = [];
  public bookingType: number = 1; // 1 = scheduled, 2 = HIP, 3 = EHA
  public hideOnHomePage: boolean = false;
  public overrideQuestionDesc: {};

  // out of hours
  public oohHourlyRate: number = null;
  public oohCalloutFee: number = null;
}

export class JobType {
  public id: number = 0;
  public name: string = '';
  public icon: string = '';
  public hideIcon: boolean = false;
  public route: string = '';
  public partsIconBase: string = '';
  public partsIconPremium: string = '';
  public partsCostBase: number = 0;
  public partsCostPremium: number = 0;
  public partsNameBase: string = 'Standard';
  public partsNamePremium: string = 'Premium';
  public partsInfoBase: string = '';
  public partsInfoPremium: string = '';
  public productCode: string = '';
  public attendanceHours: number = 1;
  public emergency: boolean = false;
  public confirmPopupKey: string = '';
  public redirectTrade: string = '';
  public questions: Array<TriageQuestion> = [];
  public inclusions: string = '';

  public calloutFee: number = 0;
  public additionalPartsFree: boolean = false;

  // out of hours
  public oohCalloutFee: number = null;
  public oohAttendanceHours: number = null;

  public showGeneralNotes: boolean = true;
  public showJobPhotos: boolean = true;

  // used by booking platform only
  public jobTypeIndex: number = -1;
  public currentBasePartsCost: number = 0;
  public currentPremiumPartsCost: number = 0;
  public estimatedCurrentPrice: number = 0;
  public estimatedFullPrice: number = 0;
  public estimatedDuration: number = 0;
  public currentQuantity: number = 0;
  public firstQuestionIndex: number = -1;
  public standardModel: boolean = false;
  public currentAttendanceHours: number = 0;
  public currentHourlyMultiplier: number = 0;
}

export class TriageQuestion {
  public id: number = 0;
  public icon: string = '';
  public description: string = '';
  public jobTypeID: number = 0;
  public questionTypeID: number = 0;
  public listOrder: number = 0;
  public nextPopup: string = '';
  public nextPopupKey: string = '';
  public options: Array<TriageQuestionOption> = [];
  public data: string = '';
  public progressStep: number = 1;
  public required: boolean = true;
  public outgoingField: boolean = true;

  public additionalFixedCost: number = 0;
  public additionalFixedCostAnswer: string = '';
  public additionalFixedCostAnswerMatrix: Array<AdditionalFixedPriceMatrixItem> = [];
  public additionalPerCost: number = 0;
  public additionalPerCostAnswer: string = '';

  public modifiedBasePartsCost: number = 0;
  public modifiedBasePartsAnswer: string = '';
  public modifiedPremiumPartsCost: number = 0;
  public modifiedPremiumPartsAnswer: string = '';

  public modifiedAttendanceHours: number = 0;
  public modifiedAttendanceHoursAnswer: string = '';
  public modifiedHourlyMultiplier: number = 0;
  public modifiedHourlyMultiplierAnswer: string = '';

  public quantity: boolean = false;
  public startPricing: boolean = false;
  public hourlyMultiplier: number = 0;
  public partsMultiplier: number = 0;
  public partsAdd: number = 0;

  public defaultAnswer: string = '';

  public showStandardButtons: boolean = true;
  public showConfirmButtons: boolean = false;
}

export class TriageQuestionOption {
  public id: number = 0;
  public name: string = '';
  public icon: string = '';
  public data: Array<string> = [];
  public fullAnswer: string = '';
}

export class TriageQuestionData {
  public question: TriageQuestion = null;
  public answer: string = '';
  public fullAnswer: string = '';
  public show: boolean = false;
  public showPopup: boolean = false;
  public popupShown: boolean = false;
  public index: number = 0;
  public valid: boolean = false;

  // used by booking platform only
  public jobTypeIndex: number = -1;
}

export class AdditionalFixedPriceMatrixItem {
  public answer: string = '';
  public price: number = 0;
}
